'use client'

import _ from 'lodash'
import { LoaderCircle } from 'lucide-react'

import { LevelFooter } from '../Footer'
import { HUD } from '../HUD'
import { LevelToolbar } from '../Toolbar'

import { useLevelContext } from '@/features/level-play'
import { ChallengeStep, useFlow } from '@/shared/lib/steps-flow'
import { showErrorAlert } from '@/shared/lib/ui'
import { Button } from '@/shared/ui/Button'


interface GameIframeProps {
  step: ChallengeStep
  challengeId: number
}

export function GameIframe({ challengeId }: GameIframeProps) {
  const { goNext, enableContinue, verifyChallenge } = useFlow()
  const { level, isSubmitting, onChallengeAnswer, getMinimumAdvanceStatus } =
    useLevelContext()

  const challenge = level?.active_challenges.find(c => c.id === challengeId)
  const minimumAdvance = getMinimumAdvanceStatus(challengeId)
  const { meta } = challenge
  const iframe = _.get(meta, 'iframe')

  const handleContinue = async () => {
    if (!challenge) return

    try {
      const { ok } = await onChallengeAnswer({
        uid: challenge.uid,
        answer: 'Visualizado',
        skipValidation: true
      })

      if (ok) enableContinue()
      verifyChallenge({ correct: true })
      goNext()
    } catch (error) {
      showErrorAlert(error)
    }
  }

  return (
    <HUD.Card>
      <HUD.Header challenge={challenge} />
      <HUD.Toolbar>
        <LevelToolbar />
      </HUD.Toolbar>
      <HUD.Body className="flex flex-col gap-4">
        <HUD.Description challenge={challenge} />

        <div className="w-full min-h-[400px]">
          <div
            className="w-full h-full"
            dangerouslySetInnerHTML={{ __html: iframe }}
          />
        </div>
      </HUD.Body>

      <LevelFooter>
        <Button
          type="button"
          onClick={handleContinue}
          className="w-full font-bold btn btn-info"
          disabled={minimumAdvance.isLocked || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <LoaderCircle className="size-5 animate-spin" />
              <span>Carregando</span>
            </>
          ) : (
            <span>
              {minimumAdvance.isLocked
                ? `Aguarde ${minimumAdvance.label}`
                : 'Continuar'}
            </span>
          )}
        </Button>
      </LevelFooter>
    </HUD.Card>
  )
}
